module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Padding ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicOverflow'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Overflow\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicTypography'
      }
    }
  }, [_vm._v("\n            Typography   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-padding"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Padding\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Padding")]), _vm._v(" "), _c('li', [_vm._v("• Padding Left")]), _vm._v(" "), _c('li', [_vm._v("• Padding Right")]), _vm._v(" "), _c('li', [_vm._v("• Padding Top")]), _vm._v(" "), _c('li', [_vm._v("• Padding Bottom")]), _vm._v(" "), _c('li', [_vm._v("• Padding Vertical")]), _vm._v(" "), _c('li', [_vm._v("• Padding Horizontal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-left")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdr-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-right")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-top")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdbt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-bottom")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdv-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-top")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-bottom")]), _vm._v(" (Vertical)")]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdh-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-left")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-right")]), _vm._v(" (Horizontal)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdl-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdr-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdbt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdv-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdh-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Padding")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Padding -->\n<div class=\"_pd-2px\"></div>\n<div class=\"_pd-4px\"></div>\n<div class=\"_pd-8px\"></div>\n<div class=\"_pd-16px\"></div>\n\n<!-- Padding Left -->\n<div class=\"_pdl-2px\"></div>\n<div class=\"_pdl-4px\"></div>\n<div class=\"_pdl-8px\"></div>\n<div class=\"_pdl-16px\"></div>\n\n<!-- Padding Right -->\n<div class=\"_pdr-2px\"></div>\n<div class=\"_pdr-4px\"></div>\n<div class=\"_pdr-8px\"></div>\n<div class=\"_pdr-16px\"></div>\n\n<!-- Padding Vertical -->\n<div class=\"_pdv-2px\"></div>\n<div class=\"_pdv-4px\"></div>\n<div class=\"_pdv-8px\"></div>\n<div class=\"_pdv-16px\"></div>\n\n<!-- Padding Horizontal -->\n<div class=\"_pdh-2px\"></div>\n<div class=\"_pdh-4px\"></div>\n<div class=\"_pdh-8px\"></div>\n<div class=\"_pdh-16px\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-2px"
  }, [_c('small', [_vm._v("_pd-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-4px"
  }, [_c('small', [_vm._v("_pd-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-8px"
  }, [_c('small', [_vm._v("_pd-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-16px"
  }, [_c('small', [_vm._v("_pd-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-2px"
  }, [_c('small', [_vm._v("_pdl-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-4px"
  }, [_c('small', [_vm._v("_pdl-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-8px"
  }, [_c('small', [_vm._v("_pdl-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-16px"
  }, [_c('small', [_vm._v("_pdl-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-2px"
  }, [_c('small', [_vm._v("_pdr-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-4px"
  }, [_c('small', [_vm._v("_pdr-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-8px"
  }, [_c('small', [_vm._v("_pdr-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-16px"
  }, [_c('small', [_vm._v("_pdr-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-2px"
  }, [_c('small', [_vm._v("_pdv-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-4px"
  }, [_c('small', [_vm._v("_pdv-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-8px"
  }, [_c('small', [_vm._v("_pdv-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-16px"
  }, [_c('small', [_vm._v("_pdv-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-2px"
  }, [_c('small', [_vm._v("_pdh-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-4px"
  }, [_c('small', [_vm._v("_pdh-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-8px"
  }, [_c('small', [_vm._v("_pdh-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-16px"
  }, [_c('small', [_vm._v("_pdh-16px")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54347f28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicPadding.vue
// module id = 132
// module chunks = 0